import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import InstallationsCard from "../../Components/InstallationsCard";
import WrapperSignupDetails from "../../Components/Wrappers/WrapperSignupDetails";
import useSetInstallationsApi from "../../Global/Api/Signup/setInstallationsApi";
import { useGetInstallationsQuery } from "../../Store/Builder/techsbook.api";
import { setLoader } from "../../Store/Slice/techsbookSlice";
import useGetInstallationsApi from "../../Global/Api/Shared/useGetInstallationsApi";
import {Paginate} from "../../Components/Paginate";

export default function Installations() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useGetInstallationsApi();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [pickedItem, setPickedItem] = useState(null);

  const handleButton = () => {
    navigate("/register-providers", {
      state: { installation_id: pickedItem, ...location?.state },
    });
  };

  useEffect(() => {
    if (pickedItem) {
      setButtonDisabled(false);
    }
  }, [pickedItem]);

  return (
    <WrapperSignupDetails
      isButtonDisabled={buttonDisabled}
      step="1"
      handleButton={handleButton}
    >
      <h1 className="register__subtitle">
        What type of installations do you need completed?
      </h1>
      <div className="register__grid">
        {data?.map((item) => (
          <InstallationsCard
            key={item?.id}
            title={item?.name}
            descr={item?.description}
            id={item?.id}
            image={item?.image}
            name="installations"
            setPickedItem={setPickedItem}
          />
        ))}
      </div>
    </WrapperSignupDetails>
  );
}
